import React, { useEffect, useRef, useState} from 'react'
import { motion } from 'framer-motion'
import { FaOpencart } from 'react-icons/fa';

import './products.css'

function Products({products,  onAddToCart}) {

    const [width, setWidth] = useState(0)
    const carousel = useRef()

    useEffect(() => {
        setWidth(carousel.current.scrollWidth - carousel.current.offsetWidth)
    }, [products])

    if (products.length <= 0 || products == null) (
        <p>Loading...</p>
    )


    return (
        <div className='container-fluid'>
               <motion.div ref={carousel} className='carousel product-carousel' whileTap={{cursor: "grabbing"}}>
                <motion.div drag="x" dragConstraints={{right: 0, left: -width}} className='carousel-inner'>
                    {products.map(product => (
                        <motion.div key={product.id} className={`carousel-item img-with-desc`}>
                            <img src={product.image.url} alt='' />
                            <div className='description'>
                                <div>
                                    <p className='serif'>{product.name}</p>
                                    <p className='price'>{product.price.formatted_with_symbol}</p>
                                </div>
                                <button onClick={() => onAddToCart(product.id, 1)} className='btn btn-cart'><FaOpencart /></button>
                            </div>
                        </motion.div>
                    ))}
                </motion.div>
            </motion.div>
        </div>
    )
}

export default Products